module.exports = __webpack_public_path__ + "static/img/logo1.51139dc8.png";